"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _styles = require("@mui/material/styles");
var _lightTheme = _interopRequireWildcard(require("./light/light-theme.js"));
var _darkTheme = _interopRequireWildcard(require("./dark/dark-theme.js"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _merge = _interopRequireDefault(require("lodash/merge"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Creates an Ethos theme, based on one of our standard themes.
 *
 * @example <caption>Create a theme that overrides the large breakpoint value</caption>
 *
 * createEDSTheme('light', {
 *     breakpoints: {
 *         values: {
 *             lg: '1500',
 *         }
 *     }
 * })
 *
 * @since v0.0.13
 *
 * @param {theme} baseTheme    The theme to use as the basis of new new theme. Valid values: 'light', 'dark'.
 * @param {object} [overrides] Overrides to the base theme
 * @return {object}            The Ethos theme
 */
function createEDSTheme(baseTheme, overrides) {
  var theme = (0, _cloneDeep.default)(_lightTheme.default);
  var themeOptions = (0, _cloneDeep.default)(_lightTheme.lightThemeOptions);

  // grab the baseline theme
  switch (baseTheme) {
    case 'light':
      break;
    case 'dark':
      theme = (0, _cloneDeep.default)(_darkTheme.default);
      themeOptions = (0, _cloneDeep.default)(_darkTheme.darkThemeOptions);
      break;
    default:
      console.warn("createEDSTheme: Invalid base theme specified: " + baseTheme + ". Defaulting to light theme.");
      break;
  }

  // apply any overrides
  if (overrides) {
    theme = (0, _styles.createTheme)((0, _merge.default)(themeOptions, overrides));
  }
  return theme;
}
var _default = createEDSTheme;
exports.default = _default;